import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { NgImageSliderModule } from 'ng-image-slider';
import { SearchFilterPipe } from 'src/app/helpers/search-filter-pipe';
import { DirectivesModule } from '../../directives/directives.module';
import { SharedModule } from '../shared/shared.module';
import { AccountBookComponent } from './account-book/account-book.component';
import { AccountingIntegrationComponent } from './accounting-integration/accounting-integration.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { EngagementPreviewComponent } from './engagementLetter-preview/engagement-preview.component';
import { IndexRoutingModule } from './index-routing.module';
import { LoginComponent } from './login/login.component';
import { MytimeTrackerComponent } from './mytime-tracker/mytime-tracker.component';
import { OfficeDocListComponent } from './office-doc-list/office-doc-list.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SignupComponent } from './signup/signup.component';
import { SourceAttachableComponent } from './source-attachable/source-attachable.component';
import { CashFlowWorkSheetComponent } from './trail-balance-working-sheet/Cash-flow/cash-flow-work-sheet/cash-flow-work-sheet.component';
import { FsNotesComponent } from './trail-balance-working-sheet/fs-notes/fs-notes.component';
import { ViewScheduleComponent } from './trail-balance-working-sheet/working-schedules/view-schedule/view-schedule.component';
import { StockholdersequityComponent } from './trail-balance-working-sheet/stockholdersequity/stockholdersequity.component';
import { TrailBalanceWorkingSheetComponent } from './trail-balance-working-sheet/trail-balance-working-sheet.component';
import { ClickoutsidewbDirective } from './trail-balance-working-sheet/trial-balance-ls-grouping/clickoutsidewb.directive';
import { TrialBalanceLsGroupingComponent } from './trail-balance-working-sheet/trial-balance-ls-grouping/trial-balance-ls-grouping.component';
import { BalanceSheetComponent } from './trail-balance-working-sheet/working-balance-sheet/working-balance-sheet.component';
import { WorkingCashflowComponent } from './trail-balance-working-sheet/working-cashflow/working-cashflow.component';
import { IncomeStatementComponent } from './trail-balance-working-sheet/working-income-statement/working-income-statement.component';
import { WorkbookSortingComponent } from '../remote-shared/workbook-sorting/workbook-sorting.component';
import { ResizableDrawerDirective } from 'src/app/directives/resizable.directive';
import { CoreModule } from 'src/app/core/core.module';

@NgModule({
  declarations: [
    SignupComponent,
    SetPasswordComponent,
    SearchFilterPipe,
    ClientPortalComponent,
    TrailBalanceWorkingSheetComponent,
    BalanceSheetComponent,
    WorkingCashflowComponent,
    FsNotesComponent,
    IncomeStatementComponent,
    TrialBalanceLsGroupingComponent,
    EngagementPreviewComponent,
    CashFlowWorkSheetComponent,
    OfficeDocListComponent,
    AccountBookComponent,
    AccountingIntegrationComponent,
    MytimeTrackerComponent,
    StockholdersequityComponent,
    ClickoutsidewbDirective,
    LoginComponent
  ],
    imports: [
      SharedModule,
      IndexRoutingModule,
      DragDropModule,
      DirectivesModule,
      MatStepperModule,
      MatListModule,
      NgImageSliderModule,
      MatDialogModule,
      NgOptimizedImage,
      WorkbookSortingComponent,
      ResizableDrawerDirective,
      CoreModule,
      SourceAttachableComponent,
      ViewScheduleComponent
    ],
  providers: []
})
export class IndexModule {
}
